import React from 'react';
import PropTypes from 'prop-types';
import VisibilityIcon from '@material-ui/icons/Visibility';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { FormFor } from 'react-rails-form-helpers';

const ViewListItem = (props) => {
  const {
    itemId, path, forwardedRef, currentPage,
  } = props;
  const urlView = path.replace(':id', itemId);

  const viewNameForm = `view-${itemId}`;

  return (
    <FormFor
      url={urlView}
      method="get"
      id={viewNameForm}
      name={viewNameForm}
    >
      <input
        name="page"
        value={currentPage}
        type="hidden"
      />
      <ListItem
        button
        type="submit"
        component="button"
        form={viewNameForm}
        className="viewButton"
        ref={forwardedRef}
      >
        <ListItemIcon>
          <VisibilityIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary="Visualizar" />
      </ListItem>
    </FormFor>
  );
};

ViewListItem.propTypes = {
  itemId: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  forwardedRef: PropTypes.func,
  currentPage: PropTypes.number,
};

// eslint-disable-next-line react/jsx-props-no-spreading
export default React.forwardRef((props, ref) => <ViewListItem {...props} forwardedRef={ref} />);
